<template>
  <component :is="layout">
    <router-view />
  </component>

  <cookiesConsent v-if="showCookiesConsent && isShowCookiesConsent" />
</template>

<script>
import MainLayout from '../layouts/MainLayout';
import AuthLayout from '../layouts/AuthLayout.vue';
import DefaultLayout from '../layouts/DefaultLayout.vue';
import cookiesConsent from '../nest_components/cookiesConsent.vue';

export default {
  name: "Layout",

  components: {
    MainLayout,
    AuthLayout,
    DefaultLayout,
    cookiesConsent
  },

  data() {
    return {
      showCookiesConsent: false
    };
  },

  mounted() {
    const consent = localStorage.getItem('cookies_consent');
    this.showCookiesConsent = !consent;
  },

  computed: {
    layout() {
      const routeLayout = this.$route.meta.layout || 'def';
      return routeLayout === 'auth'
        ? AuthLayout
        : routeLayout === 'main'
        ? MainLayout
        : DefaultLayout;
    },

    isShowCookiesConsent() {
      if (this.$route.path == '/sso' || this.$helper.isSSOLoggedIn()) {
        return false
      } else {
        return true
      }
    }
  }
};
</script>
